/* istanbul ignore file */
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';
import { PayloadAction } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions as visibilityTrackingActions } from 'src/redux/visibilityTracking';
import { selectSortingOption } from '../modules/selectors';
import { actions } from '../modules/slice';
import { STICKY_FILTER_MENU_VISIBILITY_NAME, StickyMenuImpression } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [actions.selectSortOption.type]: (state, nextState, action) => {
    const { payload: sortOptionId } = action as PayloadAction<string>;
    const sortOption = selectSortingOption(state, sortOptionId);

    if (sortOption) {
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Sort Results',
        event_action: 'sort by',
        event_label: sortOption.title,
      });
    }
  },
  [visibilityTrackingActions.getSectionVisibleActionType(STICKY_FILTER_MENU_VISIBILITY_NAME)]:
    () => {
      sendGAEvent<StickyMenuImpression>({
        event: 'custom_event',
        event_action: 'filter & sort sticky impression',
        event_category: 'Filter & sort',
        event_label: 'icon',
      });
    },
};
